import BigNumber from 'bignumber.js'

export enum FetchStatus {
  NOT_FETCHED = 'not-fetched',
  SUCCESS = 'success',
  FAILED = 'failed',
}
export type UseTokenBalanceState = {
  balance: BigNumber
  fetchStatus: FetchStatus
}
